<template>
  <li class="snap-start">
    <slot />
  </li>
</template>
